<template>
  <div class="min-h-screen bg-secondary-50 dark:bg-secondary-900">
    <!-- Banner Superior -->
    <div class="relative bg-primary-600">
      <div class="max-w-[95vw] mx-auto py-3 px-4 sm:px-6 lg:px-8">
        <div class="flex items-center justify-between flex-wrap">
          <div class="flex-1 flex items-center">
            <span class="flex p-2">
              <svg
                class="h-6 w-6 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </span>
            <p class="ml-3 font-medium text-white truncate">
              <span>Kila - Key International Logistics Assistant</span>
            </p>
          </div>
          <div class="flex items-center space-x-4">
            <!-- Botón de Dark/Light Mode -->
            <div class="absolute right-4">
              <LanguageSelector />
            </div>
            <button
              @click="toggleTheme"
              class="inline-flex items-center px-3 py-1 rounded-md text-sm font-medium text-white hover:bg-primary-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-primary-800 focus:ring-white"
            >
              <!-- Sol para Light Mode -->
              <svg
                v-if="isDarkMode"
                class="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                />
              </svg>
              <!-- Luna para Dark Mode -->
              <svg
                v-else
                class="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                />
              </svg>
            </button>
            <!-- Botón de Contacto -->
                      </div>
        </div>
      </div>
    </div>

    <!-- Contenido Principal -->
    <main>
      <router-view></router-view>
    </main>

    <!-- Footer -->
    <footer
      class="bg-white dark:bg-secondary-800 border-t border-secondary-200 dark:border-secondary-700"
    >
      <div class="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
        <p
          class="text-center text-sm text-secondary-500 dark:text-secondary-400"
        >
          {{ new Date().getFullYear() }} Kila. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  </div>
</template>

<script setup lang="ts">
import LanguageSelector from "@/components/language/LanguageSelector.vue";
import { computed } from "vue";
import { useTheme } from "@/composables/useTheme";

const { theme, toggleTheme } = useTheme();

const isDarkMode = computed(() => theme.value === 'dark');
</script>
